module.exports = __webpack_public_path__ + "media/assets/images/flags/ve-b8e97d642f519fd905e6408a2418bbb1.svg";